import React from 'react';
import { CheckIcon, LockIcon, ShieldCheckIcon, TrophyIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, included, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="tech-grid-light scroll-mt-4 bg-canvas py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-163" data-mp="1j9gz2sqezjay">
      <div className="mx-auto max-w-3xl px-4" data-id="element-164" data-mp="1n9r0rt76bnk0">
        <h2 id="pricing-title" className="text-center text-3xl font-extrabold text-navy-900 sm:text-4xl" data-id="element-165" data-mp="1s9n7i0799t39">
          Elige tu pack
        </h2>

        <article className="mt-10 overflow-hidden rounded-2xl border border-navy-100 bg-white shadow-[0_24px_60px_rgba(11,33,64,0.14)]" data-id="element-166" data-mp="1x9rqbwvmyzwn">
          <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-167" data-mp="225qhfs8cmw0r" />
          <div className="p-6 sm:p-10" data-id="element-168" data-mp="2w0gaw9eae0o">
            <span className="inline-flex items-center gap-2 rounded-md bg-navy-900 px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.16em] text-white" data-id="element-169" data-mp="2x1rd0qev0ie">
              <TrophyIcon className="h-3.5 w-3.5 text-sun-400" aria-hidden="true" data-id="element-170" data-mp="1mi99j1nzuuiq" /> Oferta principal
            </span>

            <div className="mt-5 flex flex-col gap-6 border-b border-navy-100 pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-171" data-mp="1hnvb0qe1c79u">
              <div data-id="element-172" data-mp="17s21lfvm4twa">
                <h3 className="text-2xl font-extrabold leading-tight text-navy-900" data-id="element-173" data-mp="17sjv44qw4u0i">{productShortName}</h3>
                <p className="mt-2 text-sm text-navy-700" data-id="element-174" data-mp="25ehj2ho1hrju">
                  Los {totalVolumes} tomos + {totalBonuses} bonos estratégicos listos para usar en el aula.
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-175" data-mp="1vg1ou5tpu264">
                <span className="text-sm text-navy-700" data-id="element-176" data-mp="1rfri2qy3n7q7">
                  Precio regular: <span className="line-through" data-id="element-177" data-mp="1rhu6x7nimutc">{priceBefore}</span>
                </span>
                <p className="mt-1 flex items-baseline gap-2 sm:justify-end" data-id="element-178" data-mp="k3iswz8nif3o">
                  <span className="text-sm font-bold uppercase text-navy-700" data-id="element-179" data-mp="fzt88kv3khnx">Hoy:</span>
                  <span className="font-display text-5xl font-extrabold text-navy-900" data-id="element-180" data-mp="hit6n9qh5y8k">{price}</span>
                </p>
                <p className="mt-2 inline-block rounded-md bg-sun-400 px-2.5 py-1 text-xs font-extrabold uppercase tracking-[.14em] text-navy-950" data-id="element-181" data-mp="mgckw9n6ab0i">
                  50% de descuento
                </p>
              </div>
            </div>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-182" data-mp="3uwo1xxb78mva">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-navy-900" data-id="element-183" data-mp="3hqhup83i9ty">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-leaf-600" aria-hidden="true" data-id="element-184" data-mp="3kyqevd52sw49" />
                  {item}
                </li>)}
            </ul>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-185" data-mp="3pv8ha6cxoidf">
              Quiero el Megapack
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-navy-700" data-id="element-186" data-mp="3fyvs9lsc2sp0">
              <span className="inline-flex items-center gap-1.5" data-id="element-187" data-mp="2xd7h7ghuhki7">
                <LockIcon className="h-4 w-4 text-leaf-600" aria-hidden="true" data-id="element-188" data-mp="2sdbmk7v1f5fb" /> Pago seguro
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-189" data-mp="36dcn1m7e4au9">
                <ZapIcon className="h-4 w-4 text-leaf-600" aria-hidden="true" data-id="element-190" data-mp="31cf5nbu7fktt" /> Acceso inmediato
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-191" data-mp="3g8o3c8yg5q44">
                <ShieldCheckIcon className="h-4 w-4 text-leaf-600" aria-hidden="true" data-id="element-192" data-mp="3bbe6474tga5q" /> Garantía 7 días
              </span>
            </div>
            <p className="mt-4 text-center text-xs text-navy-700" data-id="element-193" data-mp="3p1regalmdqvl">
              Pagas en USD. Tu plataforma de pago muestra la conversión a tu moneda local automáticamente.
            </p>
          </div>
        </article>
      </div>
    </section>;
}